import { useContext, reactive, computed } from "@nuxtjs/composition-api";
import { decodeUid } from "@wemade-vsf/core/lib/runtime/helpers";
var PriceTypeEnum = /* @__PURE__ */ ((PriceTypeEnum2) => {
  PriceTypeEnum2["FIXED"] = "FIXED";
  PriceTypeEnum2["PERCENT"] = "PERCENT";
  return PriceTypeEnum2;
})(PriceTypeEnum || {});
const state = reactive({
  selectedOptions: [],
  enteredOptions: []
});
function useCustomOptions() {
  const { app: { $fc } } = useContext();
  const calculatePrice = (params) => {
    const { productPrice, optionPrice, priceType } = params;
    if (priceType === "PERCENT" /* PERCENT */) {
      const amount = productPrice * optionPrice / 100;
      return amount;
    }
    return optionPrice;
  };
  const getTitleWithPrice = (params) => {
    const { title } = params;
    if (!params.optionPrice)
      return title;
    const price = calculatePrice(params);
    const priceString = price > 0 ? " + " + $fc(price) : price === 0 ? "" : " -" + $fc(price * -1);
    return title + priceString;
  };
  const reset = () => {
    state.selectedOptions = [];
    state.enteredOptions = [];
  };
  const priceForOptions = computed(() => {
    let price = 0;
    state.selectedOptions.forEach((o) => {
      if (o.price)
        price = price + o.price;
    });
    state.enteredOptions.forEach((o) => {
      if (o.price)
        price = price + o.price;
    });
    return price;
  });
  const optionSelected = (option) => {
    if (!option.id) {
      const optionId = decodeUid(option.uid);
      if (optionId) {
        option.id = parseInt(optionId.replace("custom-option/", ""));
      }
    }
    const index = state.selectedOptions.findIndex((o) => o.uid === option.uid);
    let selectedOptions = state.selectedOptions;
    if (index === -1) {
      selectedOptions.push(option);
    } else {
      selectedOptions.splice(index, 1, option);
    }
    state.selectedOptions = selectedOptions;
  };
  const optionEntered = (option) => {
    if (!option.id) {
      const optionId = decodeUid(option.uid);
      if (optionId) {
        option.id = parseInt(optionId.replace("custom-option/", ""));
      }
    }
    const index = state.enteredOptions.findIndex((o) => o.uid === option.uid);
    let enteredOptions = state.enteredOptions;
    if (index === -1) {
      enteredOptions.push(option);
    } else {
      enteredOptions.splice(index, 1, option);
    }
    state.enteredOptions = enteredOptions;
  };
  const customOptions = computed(() => {
    let options = [];
    state.selectedOptions.forEach((opt) => {
      if (Array.isArray(opt.value)) {
        opt.value.forEach((v) => {
          const decodedValue = decodeUid(v);
          const valueId = decodedValue.split("/").pop();
          options.push({
            id: opt.id,
            value_string: valueId
          });
        });
      } else {
        const decodedValue = decodeUid(opt.value);
        const valueId = decodedValue.split("/").pop();
        options.push({
          id: opt.id,
          value_string: valueId
        });
      }
    });
    state.enteredOptions.forEach((opt) => {
      options.push({
        id: opt.id,
        value_string: opt.value
      });
    });
    return options;
  });
  return {
    calculatePrice,
    getTitleWithPrice,
    reset,
    optionSelected,
    optionEntered,
    customOptions,
    selectedOptions: computed(() => state.selectedOptions.reduce((acc, option) => {
      if (Array.isArray(option.value)) {
        for (let i = 0, j = option.value.length; i < j; i++) {
          acc[`${option.uid}-${i}`] = option.value[i];
        }
      } else {
        acc[option.uid] = option.value;
      }
      return acc;
    }, {})),
    enteredOptions: computed(() => state.enteredOptions.map((o) => ({ uid: o.uid, value: o.value }))),
    priceForOptions
  };
}
export {
  PriceTypeEnum,
  useCustomOptions
};
